<template>
  <div class="subject">
    <!-- 标题 -->
    <img
      class="subject_background"
      src="../../../../static/ningbo/ningbo_log/SelectTopic.png"
      alt=""
    />
    <div class="subject_title">
      <div class="subject_title_01">请选择主题开始创作</div>
    </div>
    <div class="subject_main">
      <div class="subject_main_01">
        <div class="subject_main_element" @click="toMatting(`girl`)">
          <img
            class="subject_main_element_ground"
            src="../../../../static/ningbo/ningbo_log/SelectTopic01.png"
            alt=""
          />
          <div class="title">
            <div class="title_01">女孩</div>
            <div class="title_02">“任意照片”一键变卡</div>
          </div>
        </div>
        <div class="subject_main_element" @click="toMatting(`boy`)">
          <img
            class="subject_main_element_ground"
            src="../../../../static/ningbo/ningbo_log/SelectTopic02.png"
            alt=""
          />
          <div class="title">
            <div class="title_01">男孩</div>
            <div class="title_02">“任意照片”一键变卡</div>
          </div>
        </div>
      </div>
      <div class="subject_main_01">
        <div class="subject_main_element" @click="toMatting(`lovers`)">
          <img
            class="subject_main_element_ground"
            src="../../../../static/ningbo/ningbo_log/SelectTopic03.png"
            alt=""
          />
          <div class="title">
            <div class="title_01">情侣</div>
            <div class="title_02">“任意照片”一键变卡</div>
          </div>
        </div>
        <div class="subject_main_element" @click="toMatting(`cute`)">
          <img
            class="subject_main_element_ground"
            src="../../../../static/ningbo/ningbo_log/SelectTopic04.png"
            alt=""
          />
          <div class="title">
            <div class="title_01">萌宠</div>
            <div class="title_02">“任意照片”一键变卡</div>
          </div>
        </div>
      </div>
    </div>
    <div class="subject_foot">
      <div class="bottom_button">
        <div class="right_button" @click="back()">
          <div class="element">←</div>
          <div class="element">上一步</div>
        </div>
        <!-- <div class="right_button" @click="next()">
          <div class="element">→</div>
          <div class="element">预览</div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "selectTopic_ccb",
  data() {
    return {};
  },
  mounted() {},
  methods: {
    toMatting(log) {
      // this.$router.push({
      //   name: "matting_ccb",
      //   params: {
      //     log: log,
      //   },
      // });
      this.$router.push({
        name: `matting_ccb${log}`,
        params: {
          log: log,
        },
      });
    },
    back() {
      this.$router.push({
        name: "home_ccb",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.subject {
  width: 100%;
  height: 60rem;
  background-color: white;
  .subject_background {
    width: 100%;
  }
  .subject_title {
    position: absolute;
    top: 2.8rem;
    left: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .subject_title_01 {
      font-size: 1.4rem;
      font-weight: 800;
      color: #0d1632;
    }
  }
  .subject_main {
    position: absolute;
    top: 6rem;
    width: 100%;
    height: 60rem;
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    .subject_main_01 {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 2rem;
      .subject_main_element {
        width: 48%;
        height: 15rem;
        border: 1px solid #023bb6;
        border-radius: 2rem;
        background: linear-gradient(to top, #ffffff, #cce3f9);
        text-align: center;
        padding: 0.8rem 0 1rem 0;
        .subject_main_element_ground {
          width: 90%;
        }
        .title {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title_01 {
            font-size: 1rem;
            font-weight: 900;
          }
          .title_02 {
            color: #92969b;
            font-size: 0.6rem;
            font-weight: 100;
          }
        }
      }
    }
  }
  .subject_foot {
    position: absolute;
    top: 40rem;
    padding: 0 1rem;
    .bottom_button {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .left_button {
        width: 40%;
        height: 2.4rem;
        padding-top: 0.4rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        border: 1px solid #093695;
        border-radius: 1.2rem;
        .element {
          font-weight: 500;
          font-size: 1rem;
          color: #093695;
          font-family: "黑体", "Microsoft YaHei", sans-serif;
        }
      }
      .right_button {
        width: 10rem;
        height: 2.4rem;
        padding-top: 0.4rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        // border: 1px solid #023bb6;
        background: linear-gradient(to right, #093695, #0d1632);
        border-radius: 1.2rem;
        .element {
          font-weight: 500;
          font-size: 1rem;
          color: white;
          font-family: "黑体", "Microsoft YaHei", sans-serif;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CCB_demo/Matting/SelectTopic.vue